import { clsx } from "clsx"
import "./style.scss"

interface IContainerProps extends React.HTMLAttributes<HTMLElement> {}

export const Container = (props: IContainerProps) => {
  return <div {...props} className={clsx("container", props.className)} />
}
